import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as RoleComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import * as ANT from 'antd';
import moment from 'moment';
import DEFINE, { DATE_TIME_FORMAT } from "../../../../constants/Define";

let permisionActions = [];
class Roles extends Component {

    state = {
        titleTable: Func.getTitleTable(Model.RolesModel.titleTable, ['action'], ['id']),
        modelRole: Model.RolesModel.titleTable,
        componentTable: {
            name: {
                key: "name",
                sorter: (i, k) => i.name.length - k.length,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            action: {
                align: 'center',
                width: 100,
                render: (text, record) => <RoleComponent.EditComponent item={record} permisionActions={permisionActions}
                    onDeleteRole={this.props.onDeleteRole} />,
            },
            createdDate: {
                sorter: (i, k) => i.createdDate.length - k.length,
                render: (createdDate) => createdDate && createdDate.format(DATE_TIME_FORMAT.DATE_TIME),
            },
        },
        roles: [],
        pageSize: this.props.roles.data.pageSize,
        pageIndex: this.props.roles.data.pageIndex,
        totalCount: this.props.roles.data.totalCount,
        totalPage: this.props.roles.data.totalPage,
        isFetching: false,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ROLE);
        this.setState({
            pageSize: this.props.roles.data.pageSize,
            pageIndex: this.props.roles.data.pageIndex,
            totalCount: this.props.roles.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.roles.data.totalCount) / parseInt(this.props.roles.data.pageSize))
        })
        this.props.onListRole({ pageSize: this.props.roles.data.pageSize, pageIndex: this.props.roles.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.roles.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.roles.data !== prevProps.roles.data) {
            this.setState({
                roles: this.props.roles.data.result,
                pageSize: this.props.roles.data.pageSize,
                pageIndex: this.props.roles.data.pageIndex,
                totalCount: this.props.roles.data.totalCount,
                totalPage: this.props.roles.data.totalCount / this.props.roles.data.pageSize,
            })
        }
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListRole(newFilters);
    };

    render() {
        const { t } = this.props;
        const { totalPage, titleTable, roles, modelRole, isFetching, totalCount, componentTable, pageSize, pageIndex } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath="roles"
                        titleHeader={t('navigation.roles')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Link to="/roles/action"
                                    className='btn btn-primary'> + {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <HMS.ListComponent
                        tableKey="role-list"
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(roles, modelRole)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'role'
                        })}
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, pageSize, current: pageIndex }}
                        componentTableList={{
                            // right: <Fragment>{
                            //     permisionActions && permisionActions.allowCreate &&
                            //     <Link to="/roles/action"
                            //         className='btn btn-primary'> + {t(`action.create`)}</Link>
                            // }
                            // </Fragment>
                        }}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        roles: state.roleReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListRole: (filters) => {
            dispatch(action.dataRoleAction(filters))
        },
        onDeleteRole: (id) => {
            dispatch(action.deleteRoleAction(id))
        }
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Roles));
